import { render } from "./FigureCaption.vue?vue&type=template&id=05b616be&ts=true"
import script from "./FigureCaption.vue?vue&type=script&lang=ts"
export * from "./FigureCaption.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__